/**
 * Entry del bundle global de vídeo servido en /v1/video.js.
 * Cargar SIEMPRE después (o junto a) /v1/u.js — reutiliza window.trackrift.
 *
 * El módulo vive en src/video/ (core + adaptadores html5/youtube/vimeo +
 * panel de debug). Ver src/video/index.ts para la API pública.
 */
import { installVideoTracking } from './video/index';

installVideoTracking();
